import { css } from 'styled-components';

export const antdPopover = css`
  .popover_dark_no-arrow {
    padding: 0;
    .ant-popover-content {
      .ant-popover-arrow {
        display: none;
      }
      .ant-popover-inner {
        > div {
          .ant-popover-inner-content {
            padding: 0;
          }
        }
      }
    }
  }
  .dd-selector-popover {
    .ant-popover-inner-content {
      padding: 0;
    }
  }
`;
